'use strict';

var count = 0;
module.exports = function uuid() {
  return 'react-tinymce-' + count++;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-tinymce/lib/helpers/uuid.js
 ** module id = 234
 ** module chunks = 1 2 4 6 8 9 11
 **/